


<!-- ================================== Add faculty Details ====================== -->

<mat-dialog-content>
<div class="tabs-container">
    <form [formGroup]="addFacultyForm" >
       
          <ion-row class="pl-10">
            <ion-col >
              <span class="font_bold ">Add Faculty Details</span>
            </ion-col>
            <ion-col class="text-right">
              <img [mat-dialog-close] class="close-btn" src="././assets/icon/close_icon.png">
            </ion-col>
          </ion-row>
      
      <div formArrayName="faculties" class="font_medium ml-10 mr-10">
        <div *ngFor="let facultyGroup of faculties.controls; let i = index" [formGroupName]="i" class="cardBox mb-20 mt-10" style="padding: 10px;">    
      <ion-row  class="responsive-form m-10 p-20">

        <!-- ================================= Faculty Name ===========================================================-->

        <ion-col size="12" size-md="4">
          <div class="formLabelRegularfs16 mb-5">Faculty Name <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="facultyName" placeholder="Enter faculty name" />
            <mat-error *ngIf="addFacultyForm.get('facultyName')?.hasError('required') && addFacultyForm.get('facultyName')?.touched">
            Faculty name is required
            </mat-error>
            <mat-error *ngIf="addFacultyForm.get('facultyName')?.hasError('pattern') && addFacultyForm.get('facultyName')?.touched">
              Faculty name should contain only characters
            </mat-error>
          </mat-form-field>
        </ion-col>
    

        <!-- ============================== Contact Number ============================================================ -->

        <ion-col size="12" size-md="4">
          <div class="formLabelRegularfs16 mb-5">Contact No. <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput type="tel" formControlName="contactNumber" placeholder="Enter contact "  maxlength="10"
            inputmode="numeric" pattern="[0-9]*"/>
            <mat-error *ngIf="addFacultyForm.get('contactNumber')?.hasError('required') && addFacultyForm.get('contactNumber')?.touched">
           Contact no. is required
            </mat-error>
            <mat-error *ngIf="addFacultyForm.get('contactNumber')?.hasError('pattern') && addFacultyForm.get('contactNumber')?.touched">
              Contact number must be  10 digits
            </mat-error>
            <mat-error *ngIf="addFacultyForm.get('contactNumber')?.hasError('minlength') && addFacultyForm.get('contactNumber')?.touched">
              Contact number must be  10 digits
            </mat-error>
            
            <mat-error *ngIf="addFacultyForm.get('contactNumber')?.hasError('maxlength') && addFacultyForm.get('contactNumber')?.touched">
              Contact number must be  10 digits
            </mat-error>       
          </mat-form-field>
        </ion-col>


        <!-- ===================================== Email Id ================================================================== -->
    
        <ion-col size="12" size-md="4">
          <div class="formLabelRegularfs16 mb-5">Email ID <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput type="email" formControlName="email" placeholder="Enter email ID" />
            <mat-error *ngIf="addFacultyForm.get('email')?.hasError('required') && addFacultyForm.get('email')?.touched">
             Email ID is required
            </mat-error>
             <mat-error *ngIf="hasError('email', 'email')">Enter a valid email address</mat-error>
          </mat-form-field>
        </ion-col>
    
       
    <!-- =================================== Link ====================================================================== -->

        <ion-col size="12" size-md="4">
          <div class="formLabelRegularfs16 mb-5">Link <span class="red-cl">*</span></div>
          <mat-form-field class="w-100 mat-height40 mat-input-style">
            <input matInput formControlName="link" placeholder="Enter link" />
            <mat-error *ngIf="addFacultyForm.get('link')?.hasError('required') && addFacultyForm.get('link')?.touched">
             Link is required
              </mat-error>
              <mat-error *ngIf="hasError('link', 'pattern') && addFacultyForm.get('link')?.touched">
                Enter a valid link (e.g., https://example.com)
              </mat-error>
          </mat-form-field>
        </ion-col>

      <!-- ================================  Details ============================================================== -->
        
        <ion-col size="12" size-md="4">
          <div class="formLabelRegularfs16 mb-5">Details <span class="red-cl">*</span></div>
          <mat-form-field class="w-100  mat-input-style">
            <textarea matInput formControlName="details" placeholder="Enter details" rows="1"></textarea>

            <mat-error *ngIf="addFacultyForm.get('details')?.hasError('required') && addFacultyForm.get('details')?.touched">
             Details is required
             </mat-error>
             <mat-error *ngIf="addFacultyForm.get('details')?.hasError('maxlength') && addFacultyForm.get('details')?.touched">
              Maximum 255 characters allowed
            </mat-error>
          </mat-form-field>
        </ion-col>

      <!-- ================================= Remove card ========================================================= -->

        <ion-col size="12" class="text-right">
          <button type="text" class="remove_btn fs-14 red-cl" (click)="removeFacultyGroup(i)" *ngIf="faculties.length > 1">
            Remove
          </button>
        </ion-col>     
      </ion-row>
      </div>
      </div>

      <!-- =========================== Add More faculty Button ============================================== -->

      <ion-row>
        <ion-col size="12" class="text-left mt-10">
          <button class="add_faculty fs-14" (click)="addFacultyGroup()">+ Add More Faculty</button>
        </ion-col>
      </ion-row>

    <!-- ===============================  Cancle button =========================================================== -->
      
      <ion-row style="padding-bottom: 15px; padding-right: 10px;">
        <ion-col size="12" class="text-right mt-10">
          <button class="back_btn fs-14" (click)="closeDialog()">Cancel</button>
          <button type="button" class="add_btn fs-14 ml-10" [style.background-color]="buttonColorName" (click)="submitFaculty()">
            Submit
          </button>
        </ion-col>
      </ion-row>
     
    </form>
  </div>
   

</mat-dialog-content>